import React, { useEffect, useRef, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import StatusContainer from '../../controls/StatusContainer';
import { ESourceBg, GetESourceName } from '../../../configurations/enums/ESource';
import { ETypeBg, GetETypeName } from '../../../configurations/enums/EType';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { useParams } from 'react-router-dom';
import { IsMobileEnv, PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import LoadingContainer from '../../controls/LoadingContainer';
import { PrintStarter } from '../settings/Prints/PrintStarter';
import { ConfirmOpdPrint } from '../settings/Prints/ConfirmOpdPrint';
import { PrescriptionLetterPrint } from '../settings/Prints/PrescriptionLetterPrint';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';


export default function LookOutConfirmed({ isActive, searchTerm, isSearch, centerId, forDate }) {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [LastPage, setLastPage] = useState(1);
    const [pagingData, setPagingData] = useState();
    const [confirmData, setConfirmData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1)
    const [printData, setPrintData] = useState()
    const printRef = useRef();
    const printLetterRef = useRef();

    useEffect(() => {
        if (isActive && centerId && forDate) {
            onSearch()
        }
    }, [isSearch, centerId, forDate])

    const OnPageChange = (e) => {
        if (isActive && centerId && forDate) {
            const { value } = e.target;
            setCurrentPage(value)
            GetTodaysConfirmed({
                CenterId: centerId,
                PageNo: value,
                PageSize: PAGE_SIZE,
                SearchTerm: searchTerm,
                ForDate: forDate
            })
        }
    }

    const onSearch = () => {
        GetTodaysConfirmed({
            CenterId: centerId,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm,
            ForDate: forDate
        })
    }
    const GetTodaysConfirmed = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetForDateConfirmed(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setConfirmData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setConfirmData([])
                // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setConfirmData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <div class="text-gray-700">
            <div class="text-center text-2xl">
                <div class="px-4 py-2 font-semibold"></div>
                {!IsMobileEnv &&
                    <div style={{ display: "none" }}>
                        <ConfirmOpdPrint printData={printData} ref={printRef} />
                        <PrescriptionLetterPrint printData={printData} ref={printLetterRef} />
                    </div>
                }
                <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData} >
                    <div className='overflow-x-auto'>
                        <table class="border w-full text-sm text-left rtl:text-right text-gray-500 ">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-200">
                                <tr>
                                    {!IsMobileEnv &&
                                        <th scope="col" class="px-3 py-3 ">
                                            Print
                                        </th>
                                    }
                                    <th scope="col" class="px-3 py-3 ">
                                        Ref.No
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Conf./Old
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Name
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Phone
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Age
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Status/Type/Source
                                    </th>
                                    <th scope="col" class="px-3 py-3">
                                        Address
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loding ?
                                    <tr class="bg-white border-b hover:bg-gray-100">
                                        <td colSpan={IsMobileEnv ? 8 : 7}>
                                            <LoadingContainer text="Fetching..." />
                                        </td>
                                    </tr>
                                    :
                                    confirmData.length > 0 ?
                                        confirmData.map((item, index) =>
                                            <tr class="bg-white border-b hover:bg-gray-100">
                                                {!IsMobileEnv &&
                                                    <td class="px-3 py-2">
                                                        <div className='flex items-center justify-center gap-1'>
                                                            <PrintStarter printRef={printRef} setPrintData={setPrintData} item={item} title="Print slip" />
                                                            <PrintStarter printRef={printLetterRef} setPrintData={setPrintData} item={item} color='blue' title="Print prescription letter" />
                                                        </div>
                                                    </td>
                                                }
                                                <td class="px-3 py-2">
                                                    {item.id}{item.registeredIdForRef && "/" + item.registeredIdForRef}
                                                </td>
                                                <td class="px-3 py-2">
                                                    <span className='font-bold text-green-500'>{item.confirmedAllotedNumber}</span>/ {item.opdNumberAlloted}
                                                </td>
                                                <td class="px-3 py-2 font-bold text-nowrap">
                                                    {item.patientName} <span className='font-normal text-[9px]'>({GetEGenderName(item.gender)})</span>
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.mobile}
                                                </td>
                                                <td class="px-3 py-2">
                                                    {item.age}
                                                </td>
                                                <td class="px-3 py-2 flex" >
                                                    <div className='mr-2'><StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} /></div>

                                                    <div className='mr-2'><StatusContainer bg={ETypeBg(item.type)} text={GetETypeName(item.type)} /></div>

                                                    <div><StatusContainer bg={ESourceBg(item.source)} text={GetESourceName(item.source)} /></div>
                                                </td>
                                                <td class="px-3 py-2  text-nowrap">
                                                    {item.patientAddress}
                                                </td>
                                            </tr>
                                        )
                                        :
                                        <tr class="bg-white border-b hover:bg-gray-100">
                                            <td colSpan={IsMobileEnv ? 7 : 8} class="px-3 py-2">
                                                <Empty>
                                                    No Items Found.
                                                </Empty>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Paging>
                <div class="pb-4"></div>
            </div>
        </div>
    )
}
